import { InputNumber, Form, Select, Row, Col } from "antd";
import { ColorPickerFormItem } from "../Image/ImageConf";
import { toRGBA } from "../parser/utils";
import { BORDER_OPTIONS } from "../constanst";

export const getFormLableStyleStr = (nodeData, rootData) => {
  const {
    hideLabel,
    labelDefaultFont,
    labelFontSize,
    labelFontColor,
    labelHorizonAlignment,
  } = nodeData;
  const {
    formLableFontSize,
    formLableFontWeight,
    formLabelColor,
  } = rootData;

  const styleArr = [];
  if (hideLabel) {
    styleArr.push("display:none");
  }
  // Node-level label styles
  if (labelDefaultFont) {
    styleArr.push(`font-family:${labelDefaultFont}`);
  }
  if (labelFontSize) {
    styleArr.push(`font-size:${labelFontSize}px`);
  } else if (formLableFontSize) {
    styleArr.push(`font-size:${formLableFontSize}px`);
  }
  if (labelFontColor) {
    styleArr.push(`color:${toRGBA(labelFontColor)}`);
  } else if (formLabelColor) {
    styleArr.push(`color:${toRGBA(formLabelColor)}`);
  }
  if (labelHorizonAlignment) {
    styleArr.push(`display:flex`);
    styleArr.push(`justify-content:${labelHorizonAlignment}`);
  }
  if (formLableFontWeight) {
    styleArr.push(`font-weight:${formLableFontWeight}`);
  }

  return styleArr.join(";");
};

export const getFormLableStyleObj = ({
  formLableFontSize,
  formLableFontWeight,
  formLabelColor,
}) => {
  return {
    fontSize: formLableFontSize,
    fontWeight: formLableFontWeight,
    color: toRGBA(formLabelColor),
  };
};

export const getBorderStyleObj = ({
  formBorderRadius,
  formBorderWidth,
  formBorderColor,
  formBorderStyle,
}) => {
  return {
    borderRadius: formBorderRadius,
    borderWidth: formBorderWidth,
    borderColor: toRGBA(formBorderColor),
    borderStyle: formBorderStyle,
  };
};

export default ({ node }) => {
  return (
    <>
      <Row gutter={8}>
        <Col span={12}>
          <Form.Item name="formLableFontSize" label="Label font size">
            <InputNumber
              defaultValue={14}
              min={0}
              max={100}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="formLableFontWeight" label="Label font weight">
            <Select
              defaultValue={"normal"}
              options={[
                { label: "Lighter", value: "lighter" },
                { label: "Normal", value: "normal" },
                { label: "Bold", value: "bold" },
              ]}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={8}>
        <Col span={12}>
          <ColorPickerFormItem
            label={"Label color"}
            name="formLabelColor"
            color={node.data.formLabelColor || { r: 0, g: 0, b: 0, a: 1 }}
          />
        </Col>
        <Col span={12}>
          <ColorPickerFormItem
            label={"Text color"}
            name="formTextColor"
            color={node.data.formTextColor || { r: 0, g: 0, b: 0, a: 1 }}
          />
        </Col>
      </Row>

      <Row gutter={8}>
        <Col span={12}>
          <ColorPickerFormItem
            label={"Placeholder color"}
            name="formPlaceholderColor"
            color={node.data.formPlaceholderColor || { r: 0, g: 0, b: 0, a: 1 }}
          />
        </Col>
        <Col span={12}>
          <ColorPickerFormItem
            label={"Error color"}
            name="formErrorColor"
            color={node.data.formErrorColor || { r: 0, g: 0, b: 0, a: 1 }}
          />
        </Col>
      </Row>

      <Row gutter={8}>
        <Col span={12}>
          <Form.Item name="formBorderWidth" label="Border width">
            <InputNumber
              defaultValue={1}
              min={0}
              max={100}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name={"formBorderStyle"} label="Border Style">
            <Select options={BORDER_OPTIONS} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={8}>
        <Col span={12}>
          <Form.Item name="formBorderRadius" label="Border radius">
            <InputNumber
              defaultValue={0}
              min={0}
              max={100}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <ColorPickerFormItem
            label={"Border color"}
            name="formBorderColor"
            color={node.data.formBorderColor || { r: 0, g: 0, b: 0, a: 1 }}
          />
        </Col>
        
      </Row>
    </>
  );
};
